<template>
  <content-loader
    :height="408"
    :width="288"
    :speed="2"
    primary-color="#f3f3f3"
    secondary-color="#ecebeb"
  >
    <rect
      x="16"
      y="16"
      rx="0"
      ry="0"
      width="256"
      height="256"
    />
    <rect
      x="16"
      y="315"
      rx="0"
      ry="0"
      width="256"
      height="17"
    />
    <rect
      x="16"
      y="288"
      rx="0"
      ry="0"
      width="81.65"
      height="17"
    />
    <rect
      x="196"
      y="371"
      rx="0"
      ry="0"
      width="74.85"
      height="33.35"
    />
    <rect
      x="16"
      y="345.05"
      rx="0"
      ry="0"
      width="156.64"
      height="17"
    />
    <rect
      x="86"
      y="390.05"
      rx="0"
      ry="0"
      width="0"
      height="0"
    />
    <rect
      x="16"
      y="379.05"
      rx="0"
      ry="0"
      width="73"
      height="16"
    />
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
    components: {
        ContentLoader,
    },
    props: [],
    methods: {
    },
}
</script>
